import * as tslib_1 from "tslib";
import Vue from "vue";
import { Component } from "vue-property-decorator";
import FeaturedItem from "@/components/search/FeaturedItem.vue";
import { Action, Getter } from "vuex-class";
let GuestSearch = class GuestSearch extends Vue {
    mounted() {
        this.getFeaturedFolders();
    }
    async getFeaturedFolders() {
        await this.retrieveFeaturedFolders();
    }
    async featuredItemClick(folderId) {
        this.$router.push({
            path: "/search/results",
            query: { folder: folderId }
        });
    }
    searchTermChanged(event) {
        // This will be triggered every time a new character is input
    }
    searchClicked() {
        if (this.searchTerm) {
            this.$router.push({
                path: `/search/results?`,
                query: { q: this.searchTerm }
            });
            this.searchTerm = "";
        }
    }
};
tslib_1.__decorate([
    Action("retrieveFeaturedFolders")
], GuestSearch.prototype, "retrieveFeaturedFolders", void 0);
tslib_1.__decorate([
    Action("getFeaturedContents")
], GuestSearch.prototype, "getFeaturedContents", void 0);
tslib_1.__decorate([
    Getter("activeFeaturedFolders")
], GuestSearch.prototype, "activeFeaturedFolders", void 0);
GuestSearch = tslib_1.__decorate([
    Component({
        name: "GuestSearch",
        components: { FeaturedItem },
        data: () => ({
            searchTerm: ""
        })
    })
], GuestSearch);
export default GuestSearch;
